import { PortableTextTypeComponentProps } from "@portabletext/react";
import VideoPlayer from "@/components/VideoPlayer";

export type ArticleVideoProps = PortableTextTypeComponentProps<{
  video: {
    asset: {
      url: string;
    };
  };
  posterImage: {
    asset: {
      url: string;
    };
  };
}>;

const ArticleVideo: React.FC<ArticleVideoProps> = (props) => {
  const { video, posterImage } = props.value;
  return <VideoPlayer src={video.asset.url} poster={posterImage.asset.url} />;
};

export default ArticleVideo;
